export const ERROR_MESSAGE = {
  CONTRACTOR_ALREADY_EXIST: 'Contractor already exists',
  SUB_CONTRACTOR_ALREADY_EXIST: 'Sub contractor already exists',
  VENDOR_ALREADY_EXIST: 'Vendor already exists',
  NO_NAME: 'Please enter a minimum of 3 characters',
};
